import { COMPANY_REGIONS } from '@shared/schema/constants.js';
import getDefaultCompanyRegion from '@/lib/getDefaultCompanyRegion.js';

const companyRegionLabels = {
  'us-west-1': 'United States — Northern California',
  'eu-north-1': 'Europe (Stockholm)'
};

export const COMPANY_REGION_STORAGE_KEY = 'organization_region';

export const companyRegionOptions = COMPANY_REGIONS.map((region) => ({
  label: `${companyRegionLabels[region] || region} (${region})`,
  value: region
}));

export const resolveCompanyRegion = (region) => (COMPANY_REGIONS.includes(region) ? region : getDefaultCompanyRegion());
